import { useState, useEffect, useContext } from "react";

// @mui core components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";

import PhoneInput from "react-phone-number-input";
import { isPossiblePhoneNumber, formatPhoneNumberIntl } from "react-phone-number-input";
import { useForm, Controller } from "react-hook-form";
import { countries as countryData } from "utils/countries";
import { AccountContext } from "context/account";

import toast from "react-hot-toast";

const AccountInfo = () => {
  const [phoneNum, setPhoneNum] = useState();
  const { id, email, phone, first_name, last_name, handleUpdateUser } = useContext(AccountContext);

  const { register, handleSubmit, trigger, setValue, getValues, reset, errors, control } =
    useForm();

  useEffect(() => {
    reset({
      email: email,
      //phone: phone,
      first_name: first_name,
      last_name: last_name,
    });

    // reset business phone number
    //setValue("phone", phone);
    //setPhoneNum(phone);
  }, [email]);

  const handleChangePhoneNumber = (value) => {
    setValue("phone", value);
    setPhoneNum(value);
  };
  const handleSave = async (data) => {
    /*
    const phoneNum = formatPhoneNumberIntl(data["phone"]);
    if (!isPossiblePhoneNumber(phoneNum)) {
      return toast.error("Not a valid phone number!");
    }*/
    try {
      const payload = {
        //phone: data["phone"],
        first_name: data["first_name"],
        last_name: data["last_name"],
      };
      await handleUpdateUser(id, payload);
      toast.success("Update account information successfully!");
    } catch (err) {
      toast.error("Update account information failed!");
    }
  };

  return (
    <Card id="account-info" sx={{ overflow: "visible" }}>
      <SuiBox p={3}>
        <SuiTypography variant="h5">Account Info</SuiTypography>
      </SuiBox>
      <SuiBox component="form" pb={3} px={3} onSubmit={handleSubmit(handleSave)}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <SuiBox display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
              <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SuiTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  required
                  textTransform="capitalize"
                >
                  account email
                </SuiTypography>
              </SuiBox>
              <SuiInput
                placeholder="Email"
                readOnly
                disabled
                {...register("email", { required: true })}
              />
            </SuiBox>
          </Grid>
          {/**
          <Grid item xs={12} sm={6}>
            <SuiBox display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
              <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SuiTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  Phone
                </SuiTypography>
              </SuiBox>

              <PhoneInput
                label="Phone"
                defaultCountry="US"
                className="upstyled-phone-input h-10 px-2 rounded-lg"
                placeholder="Enter phone number"
                name="phone"
                value={phoneNum}
                {...register("phone")}
                onChange={handleChangePhoneNumber}
              />
            </SuiBox>
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <SuiBox display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
              <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SuiTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  First Name
                </SuiTypography>
              </SuiBox>

              <SuiInput placeholder="First Name" {...register("first_name")} />
            </SuiBox>
          </Grid>
          <Grid item xs={12} sm={6}>
            <SuiBox display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
              <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SuiTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  Last Name
                </SuiTypography>
              </SuiBox>
              <SuiInput placeholder="Last Name" {...register("last_name")} />
            </SuiBox>
          </Grid>
        </Grid>
        <SuiBox
          pt={3}
          display="flex"
          justifyContent="end"
          alignItems={{ xs: "flex-start", sm: "center" }}
          flexDirection={{ xs: "column", sm: "row" }}
        >
          <SuiBox display="flex" flexDirection={{ xs: "column", sm: "row" }}>
            <SuiBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }}>
              <SuiButton variant="gradient" color="dark" sx={{ height: "100%" }} type="submit">
                save
              </SuiButton>
            </SuiBox>
          </SuiBox>
        </SuiBox>
      </SuiBox>
    </Card>
  );
};

export default AccountInfo;
